// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const yveltal: PokeData = {
  "id": 717,
  "name": "yveltal",
  "height": 58,
  "weight": 2030,
  "base_experience": 306,
  "types": [
    PokeType.DARK,
    PokeType.FLYING
  ],
  "api_moves": [
    "razor-wind",
    "gust",
    "disable",
    "hyper-beam",
    "psychic",
    "double-team",
    "sky-attack",
    "taunt",
    "roost",
    "tailwind",
    "sucker-punch",
    "dark-pulse",
    "air-slash",
    "dragon-rush",
    "focus-blast",
    "foul-play",
    "hurricane",
    "snarl",
    "phantom-force",
    "oblivion-wing"
  ],
  "moves": [
    "gust",
    "psychic",
    "sky-attack",
    "roost",
    "tailwind",
    "dark-pulse",
    "air-slash",
    "dragon-rush",
    "hurricane",
    "snarl",
    "phantom-force",
    "bite",
    "crunch"
  ],
  "evolution_chain": {
    "id": 369,
    "item": null,
    "species": [
      {
        "name": "yveltal",
        "order": 717,
        "types": [
          PokeType.DARK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 116,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
